import { Icon, Icons } from "../../components/atoms/icon";
import * as styles from "./styles.css";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
const Home = {
    url: config.standardPageRouteFragments.home,
    title: "Home",
    type: "basic",
    src: (React.createElement(Icon, { type: Icons.BottomMenuHomeInActive, className: styles.menuIconsBasic })),
    altSrc: (React.createElement(Icon, { type: Icons.BottomMenuHomeActive, className: styles.menuIconsBasic })),
};
const TabletMenuHome = {
    url: config.standardPageRouteFragments.home,
    title: "Home",
    type: "basic",
    src: React.createElement(Icon, { type: Icons.TabletMenuHome, className: styles.menuIconsBasic }),
    altSrc: (React.createElement(Icon, { type: Icons.TabletMenuHome, className: styles.menuIconsBasic })),
};
const Explore = {
    url: "/explore-v4",
    title: "Explore",
    type: "basic",
    src: (React.createElement(Icon, { type: Icons.BottomMenuExploreInActive, className: styles.menuIconsExplore })),
    altSrc: (React.createElement(Icon, { type: Icons.BottomMenuExploreActive, className: styles.menuIconsBasic })),
};
const TabletMenuExplore = {
    url: "/explore-v4",
    title: "Explore",
    type: "basic",
    src: (React.createElement(Icon, { type: Icons.TabletMenuExplore, className: styles.menuIconsBasic })),
    altSrc: (React.createElement(Icon, { type: Icons.TabletMenuExplore, className: styles.menuIconsBasic })),
};
const Shorts = {
    url: "/shorts",
    title: "Shorts",
    type: "basic",
    src: (React.createElement(Icon, { type: Icons.BottomMenuShortsInActive, className: styles.menuIconsBasic })),
    altSrc: (React.createElement(Icon, { type: Icons.BottomMenuShortsActive, className: styles.menuIconsBasic })),
};
const TabletMenuShorts = {
    url: "/shorts",
    title: "Shorts",
    type: "basic",
    src: React.createElement(Icon, { type: Icons.TabletMenuShorts, className: styles.menuIconsBasic }),
    altSrc: (React.createElement(Icon, { type: Icons.TabletMenuShorts, className: styles.menuIconsBasic })),
};
const Mindblown = {
    url: "/mindblown",
    title: "Mindblown",
    type: "basic",
    src: (React.createElement(Icon, { type: Icons.BottomMenuMindBlownInActive, className: styles.menuIconsBasic })),
    altSrc: (React.createElement(Icon, { type: Icons.BottomMenuMindBlownActive, className: styles.menuIconsBasic })),
};
const TabletMenuMindblown = {
    url: "/mindblown",
    title: "Mindblown",
    type: "basic",
    src: (React.createElement(Icon, { type: Icons.TabletMenuMindBlown, className: styles.menuIconsBasic })),
    altSrc: (React.createElement(Icon, { type: Icons.TabletMenuMindBlown, className: styles.menuIconsBasic })),
};
const Kids = {
    url: "/kids/home",
    title: "Kids",
    type: "emphasize",
    src: (React.createElement(Icon, { type: Icons.BottomMenuKidsInActive, className: styles.menuIconsEmphasize, color: "#838991" })),
    altSrc: (React.createElement(Icon, { type: Icons.BottomMenuKidsActive, className: styles.menuIconsEmphasize, color: "#FFF" })),
};
const KidsTabletMenu = {
    url: "/kids/home",
    title: "Kids",
    type: "emphasize",
    src: (React.createElement(Icon, { type: Icons.KidsPlayIconTabletMenu, className: styles.menuIconsBasic, color: "#FFF" })),
    altSrc: (React.createElement(Icon, { type: Icons.KidsPlayIconTabletMenu, className: styles.menuIconsBasic, color: "#FFF" })),
};
const Premium = {
    url: "/premium",
    title: "Premium",
    type: "basic",
    src: (React.createElement(Icon, { type: Icons.BottomMenuPremiumInActive, className: styles.menuIconsBasic })),
    altSrc: (React.createElement(Icon, { type: Icons.BottomMenuPremiumActive, className: styles.menuIconsBasic })),
};
const TabletMenuPremium = {
    url: "/premium",
    title: "Premium",
    type: "basic",
    src: (React.createElement(Icon, { type: Icons.TabletMenuPremium, className: styles.menuIconsBasic })),
    altSrc: (React.createElement(Icon, { type: Icons.TabletMenuPremium, className: styles.menuIconsBasic })),
};
const TabletMenuGoPremium = {
    url: "/go-premium-web",
    title: "Premium",
    type: "basic",
    src: (React.createElement(Icon, { type: Icons.TabletMenuPremium, className: styles.menuIconsBasic })),
    altSrc: (React.createElement(Icon, { type: Icons.TabletMenuPremium, className: styles.menuIconsBasic })),
};
const menubarMobile = [Home, Explore, Kids, Shorts, Premium];
const menubarDesktop = [Home, Explore, Kids, Shorts, Mindblown, Premium];
export const menubarTablet = [
    TabletMenuHome,
    TabletMenuExplore,
    KidsTabletMenu,
    TabletMenuShorts,
    TabletMenuMindblown,
    TabletMenuPremium,
];
export const menubarTabletForNonPremium = [
    TabletMenuHome,
    TabletMenuExplore,
    KidsTabletMenu,
    TabletMenuShorts,
    TabletMenuMindblown,
    TabletMenuGoPremium,
];
export const menuBarNavigations = window.innerWidth <= 699 ? menubarMobile : menubarDesktop;

